import React, { useContext, useEffect, useState } from "react";
import classes from "./Welcome.module.scss";
import { useNavigate } from "react-router";
import * as r from "../../../../constants/routes";
import PageMain from "../../../../components/Main/PageMain";
import ListSteps from "../../../../components/Lists/ListSteps";
// import RoundButton from "../../../../components/Buttons/RoundButton";
import { useTranslation } from "react-i18next";
import SquareButton from "../../../../components/Buttons/SquareButton/SquareButton";
// import PageHeader from "../../../../components/Headers/PageHeader";
// import { APP_NAME } from "../../../../constants/defaults";
import sessionContext from "../../../../context/sessionContext";
import useFetch from "../../../../hooks/useFetch";
import * as a from "../../../../constants/api";
import Spinner from "../../../../components/Spinner";
interface HistoryMap {
  [key: string]: {
    route: string;
    text: string;
  };
}

export default function WelcomeFirstAval() {
  const { t } = useTranslation();
  const cSession = useContext(sessionContext);
  const [_user, , , fetchUser] = useFetch({
    noAuth: true,
  });
  const [userJourneyCode, setUserJourneyCode] = useState<any>(0);
  const [buttonAdvance, setButtonAdvance] = useState<any>(<Spinner />);
  const history = useNavigate();

  const mapHistory: HistoryMap = {
    "-2": {
      route: r.R_U_TESTS,
      text: t("global.go_to_evaluation")
    },
    "-1": {
      route: r.R_U_TESTS,
      text: t("global.go_to_evaluation")
    },
    "0": {
      route: r.R_U_TESTS,
      text: t("global.go_to_evaluation")
    },
    "1": {
      route: r.R_SU_HOME,
      text: t("global.go_to_training")
    },
    "2": {
      route: r.R_U_TESTS,
      text: t("global.go_to_revaluation")
    },
    "3": {
      route: r.R_SU_HOME,
      text: t("global.go_to_results")
    },
    "4": {
      route: r.R_SU_HOME,
      text: t("global.go_to_results")
    }
  }

  useEffect(() => {
    setUserJourneyCode(_user);
  }, [_user]);

  useEffect(() => {
    if (typeof fetchUser === "function" && cSession
      && cSession?.user && cSession?.user?.token && cSession?.user?.user_permission === "10"
    ) {
      fetchUser({
        method: "GET",
        url: a.API_USER_SMART,
        header: {
          Authorization: `${cSession.user.token}`,
          userauthorization: `${cSession.user.token}`
        },
        onSuccess: (response: any) => {
        },
        onError: (error: any) => {
          console.log("error aqui", error);
        },
        onFinally: () => {
          console.log("onFinally aqui");
        }
      });
    } else if (cSession
      && cSession?.user && cSession?.user?.token && cSession?.user?.user_permission === "01") history(r.R_U_ROOT);
  }, []);

  useEffect(() => {
    if (userJourneyCode && Object.keys(userJourneyCode).includes("journey_code") && userJourneyCode?.user_shots === 0) {
      setButtonAdvance(
        <SquareButton
          text={userJourneyCode ? mapHistory[String(userJourneyCode.journey_code)].text : t("global.advance")}
          title={userJourneyCode ? mapHistory[String(userJourneyCode.journey_code)].text : t("global.advance")}
          onClick={() => {
            const isSmartInUrl = window.location.pathname.includes("smart");
            if (isSmartInUrl) {
              history(userJourneyCode && userJourneyCode !== null && mapHistory[String(userJourneyCode.journey_code)] ? mapHistory[String(userJourneyCode.journey_code)].route : "/");
              return window.location.reload();
            }
            return history(userJourneyCode && userJourneyCode !== null && mapHistory[String(userJourneyCode.journey_code)] ? mapHistory[String(userJourneyCode.journey_code)].route : "/");
          }}
        />
      );
    }
    else if (userJourneyCode?.user_shots >= 1
      && userJourneyCode?.journey_code === 3)
      setButtonAdvance(<SquareButton
        outline={true}
        text={t("global.go_to_next_journey")}
        title={t("global.go_to_next_journey")}
        onClick={() => history(r.R_U_TESTS)} />)
    else if (userJourneyCode?.user_shots >= 1) {
      setButtonAdvance(<SquareButton
      text={userJourneyCode ? mapHistory[String(userJourneyCode.journey_code !== 4 ? userJourneyCode.journey_code : 1)].text : t("global.advance")}
      title={userJourneyCode ? mapHistory[String(userJourneyCode.journey_code !== 4 ? userJourneyCode.journey_code : 1)].text : t("global.advance")}
      onClick={() => history(userJourneyCode.journey_code !== 4 ? r.R_U_TESTS : r.R_SU_HOME)} />)}
  }, [cSession, _user, userJourneyCode]);


  return (
    <>
      {/* <PageHeader
        title={t("global.welcome_to_the_platform") + " " + APP_NAME + "!"}
        subtitle={t("global.understanding_how_we_work")}
      /> */}
      <PageMain centerStretch>
        <section className={classes.Welcome}>
          {cSession?.user && cSession?.user?.token && cSession?.user?.user_permission === "10" && <ListSteps
            centerVert
            steps={[
              "Você fará uma avaliação composta por 10 testes. Cada teste tem duração média de 2 a 5 minutos. Tente fazer pausas apenas entre um teste e outro",
              "É fundamental que você use fones de ouvido",
              "Após a realização dos testes, vamos indicar um treinamento personalizado para você realizar durante 30 dias",
              // t("global.info_welcome_you_will_do_a_second_avaliation"),
            ]}
          />}
          <div className={classes.ContentFixedButton}>
            {buttonAdvance}
          </div>
        </section>
      </PageMain>
    </>
  );
}
